import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { getData } from "src/utils/axios/serverHelper";

const itemUrl = `${config.apiUrl}/item`;

export const getItemPopupList = async (
	searchText: string,
	itemAccount: string,
	itemGroup: string,
	brandCd: string,
	customCd?: string
) => {

	const url = `${itemUrl}/modal`;

	return await getData<ResponseDto<ItemDto[]>>(url, {
		params: {
			searchText, itemAccount, itemGroup, brandCd, customCd
		}
	})
}

export const getItemAllList = async () => {

	const url = `${itemUrl}/all`;

	return await getData<ResponseDto<ItemDto[]>>(url);
}


